import { useStaticQuery, graphql } from "gatsby"
import useTranslations from "hooks/useTranslations"
import Service from "components/organisms/somebuddy/Service"

export default function ServicePro(props) {
  const {
    serviceProTitle,
    servicePro1Heading,
    servicePro1Subheading,
    servicePro1Description,
    servicePro2Heading,
    servicePro2Subheading,
    servicePro2Description,
    servicePro3Heading,
    servicePro3Subheading,
    servicePro3Description,
    servicePro4Heading,
    servicePro4Subheading,
    servicePro4Description,
  } = useTranslations()
  const images = useStaticQuery(graphql`
    {
      prevent: file(relativePath: { eq: "somebuddy/prevent.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 400, layout: CONSTRAINED)
        }
      }
      protect: file(relativePath: { eq: "somebuddy/protect.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 400, layout: CONSTRAINED)
        }
      }
      impact: file(relativePath: { eq: "somebuddy/data.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 400, layout: CONSTRAINED)
        }
      }
      webapp: file(relativePath: { eq: "somebuddy/webapp.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 400, layout: CONSTRAINED)
        }
      }
    }
  `)

  const features = [
    {
      name: servicePro1Heading,
      subheader: servicePro1Subheading,
      description: servicePro1Description,
      type: "prevent",
      image: images.prevent,
    },

    {
      name: servicePro2Heading,
      subheader: servicePro2Subheading,
      description: servicePro2Description,
      type: "protect",
      image: images.webapp,
    },
    {
      name: servicePro3Heading,
      subheader: servicePro3Subheading,
      description: servicePro3Description,
      type: "protect",
      image: images.protect,
    },

    {
      name: servicePro4Heading,
      subheader: servicePro4Subheading,
      description: servicePro4Description,
      type: "impact",
      image: images.impact,
    },
  ]

  return <Service features={features} title={serviceProTitle} {...props} />
}
